exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___1z9HU .index-module__description___hhQCK{margin-bottom:.75em;font-size:22px}@media (min-width:768px){.index-module__wrapper___1z9HU .index-module__description___hhQCK{font-size:32px}}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___1z9HU",
	"description": "index-module__description___hhQCK"
};